import { createSelector } from 'reselect';

export const getOnboardingData = state => {
    return state.onboarding.data;
};

export const getEmptyStateOrgData = createSelector([getOnboardingData], state => state.empty_state_data);
